<dw-container [options]="containerOptions" *ngIf="status && message">
  <div body>
    <div><strong>Checkride Status - {{ title }}</strong></div>
    <div [innerHTML]="message"></div>
  </div>
</dw-container>
